import standardFieldsData from './standardFields';
import fieldTypes from './fieldTypes';
import unitFormats from './unitFormats';
import type {FieldTypeDefinition} from './fieldTypes';

type StandardFieldsMap = Record<string, string[]>;
export type {FieldTypeDefinition};
export type MappedField = FieldTypeDefinition & {id: string};
type MappedFieldsMap = Record<string, MappedField[]>;

const standardFields = standardFieldsData as StandardFieldsMap;

const mappedFields: MappedFieldsMap = {};
Object.entries(standardFields).forEach(([infoWindowType, fieldIds]) => {
  mappedFields[infoWindowType] = fieldIds.map((fieldId) => ({
    id: fieldId,
    ...fieldTypes[fieldId],
  }));
});

const MULTI_PICKER_DELIMITER = ';';

/** Parses a semicolon-delimited multiPicker value into an array of trimmed, non-empty strings. */
const parseMultiPickerValue = (value: unknown): string[] => {
  if (!value || typeof value !== 'string') return [];
  return value.split(MULTI_PICKER_DELIMITER).map((v) => v.trim()).filter(Boolean);
};

/** Joins an array of strings into a semicolon-delimited multiPicker value. */
const joinMultiPickerValue = (values: string[]): string => {
  return values.join(MULTI_PICKER_DELIMITER);
};

export {
  standardFields,
  fieldTypes,
  unitFormats,
  mappedFields,
  MULTI_PICKER_DELIMITER,
  parseMultiPickerValue,
  joinMultiPickerValue,
};
